import React from 'react';
import { CheckIcon } from 'lucide-react';
import { trustItems } from '../../data/content';
import { GoldSeal } from '../GoldSeal';
export function SecurePurchase() {
  return <section className="bg-white py-10 lg:py-14" aria-labelledby="secure-title" data-id="element-417" data-mp="h3osbn8bvus6">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-6 px-5 sm:flex-row sm:gap-8" data-id="element-418" data-mp="h5rtn3exlac7">
        <GoldSeal data-id="element-419" data-mp="m4w2tu1uv82j" />
        <div className="w-full" data-id="element-420" data-mp="19scls638dqgt">
          <h2 id="secure-title" className="text-center font-display text-xl font-extrabold text-ink sm:text-left sm:text-2xl" data-id="element-421" data-mp="19tf9k559bcsi">
            Comprá con total tranquilidad
          </h2>
          <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-422" data-mp="1032ng8hsnbk9">
            {trustItems.map(t => <li key={t} className="flex items-start gap-2 text-sm font-medium text-ink" data-id="element-423" data-mp="151e16ub7m67r">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-600" strokeWidth={3} aria-hidden="true" data-id="element-424" data-mp="1sri38x8r1xwn" />
                {t}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}